import React, {useEffect} from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Swipe from "react-easy-swipe";

const preloadImage = (src) => {
    const img = new Image();
    img.src = src;
};

const ModalSliderAlbum = ({ selectedPhotos, currentIndex, setCurrentIndex, closeModal }) => {
    const goNext = () => {
        setCurrentIndex((prev) => (prev + 1) % selectedPhotos.length);
    };

    const goPrev = () => {
        setCurrentIndex((prev) => (prev - 1 + selectedPhotos.length) % selectedPhotos.length);
    };

    // Preload 2 images before and after the current index
    useEffect(() => {
        const total = selectedPhotos.length;
        const indexesToPreload = [];

        for (let offset = -2; offset <= 2; offset++) {
            if (offset === 0 || total === 0) continue;

            const index = (currentIndex + offset + total) % total;
            indexesToPreload.push(index);
        }

        indexesToPreload.forEach((i) => {
            preloadImage(selectedPhotos[i]);
        });
    }, [currentIndex, selectedPhotos]);

    return (
        <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center"
            style={{ zIndex: 9999 }}
            onClick={closeModal}
        >
            <div
                className="relative w-[90%] sm:w-[80%] md:w-[70%] max-w-md sm:max-w-2xl md:max-w-3xl lg:max-w-4xl aspect-[16/9] bg-black rounded-md mx-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="w-full h-full overflow-hidden bg-black rounded-lg">
                    <Swipe onSwipeLeft={goNext} onSwipeRight={goPrev} className="w-full h-full">
                        <div className="w-full h-full flex items-center justify-center">
                            <img
                                src={selectedPhotos[currentIndex]}
                                alt={`slide-${currentIndex}`}
                                className="max-w-full max-h-full object-scale-down transition duration-500"
                            />
                        </div>
                    </Swipe>
                </div>

                {/*Previous button*/}
                <div className="absolute -left-4 md:left-0 top-1/2 -translate-y-1/2 z-20 text-white text-opacity-50 hover:text-white">
                    <button onClick={goPrev} className="text-4xl px-4 py-2">
                        <FaAngleLeft />
                    </button>
                </div>

                {/*Next button*/}
                <div className="absolute -right-4 md:right-0 top-1/2 -translate-y-1/2 z-20 text-white text-opacity-50 hover:text-white">
                    <button onClick={goNext} className="text-4xl px-4 py-2">
                        <FaAngleRight />
                    </button>
                </div>

                <div className="absolute bottom-2 left-0 right-0 text-center text-white text-sm z-20">
                    {currentIndex + 1} / {selectedPhotos.length}
                </div>
            </div>
        </div>
    );
};

export default ModalSliderAlbum;